import { render, staticRenderFns } from "./PublicModal.vue?vue&type=template&id=3cc30bfa"
import script from "./PublicModal.vue?vue&type=script&lang=js"
export * from "./PublicModal.vue?vue&type=script&lang=js"
import style0 from "./PublicModal.vue?vue&type=style&index=0&id=3cc30bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports